<template>
  <f7-page class="no-select">
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回">
      </f7-nav-left>
      <f7-nav-title>任务招标详情</f7-nav-title>
    </f7-navbar>
    <release-Header :project="this.project.projectRootVO || {}"></release-Header>
    <div class="has-content" v-if="projectType === 'assistProject'">
      <f7-link @click="assistExpanded = !assistExpanded">
        <div class="assist-item-title">
          <div>分包信息</div>
          <div>
            <f7-icon :fa="assistExpanded ? 'angle-up' : 'angle-right'"></f7-icon>
          </div>
        </div>
      </f7-link>
      <div v-show="assistExpanded">
        <assist-view
          :project="project"
          :assistMaterialsDisplay="assistMaterialsDisplay"
          :workerBenefitsDisplay="workerBenefitsDisplay"
          release="true">
        </assist-view>
      </div>
    </div>
    <div class="has-content" v-else>
      <f7-link @click="splitExpanded = !splitExpanded">
        <div class="assist-item-title">
          <div>分包信息</div>
          <div>
            <f7-icon :fa="splitExpanded ? 'angle-up' : 'angle-right'"></f7-icon>
          </div>
        </div>
      </f7-link>
      <div v-show="splitExpanded">
        <split-view
          :project="project"
          :assistMaterialsDisplay="assistMaterialsDisplay"
          release="true">
        </split-view>
      </div>
    </div>
    <contact-view :project="project"></contact-view>
  </f7-page>
</template>
<script>
import { getDict } from '@/api/common';
import { getReleaseAssist, getReleaseNormal } from '@/api/team/worker';
import ReleaseHeader from '@/components/ReleaseHeader';
import AssistView from '@/components/AssistView';
import SplitView from '@/components/SplitView';
import ContactView from '@/components/ContactView';

export default {
  props: ['projectId'],
  components: {
    ReleaseHeader,
    AssistView,
    SplitView,
    ContactView,
  },
  data() {
    return {
      projectType: this.$f7route.query.projectType,
      project: Object.assign({}, {
        validityDate: '',
        projectRootVO: {},
        projectPublishVO: {},
      }),
      assistExpanded: true,
      splitExpanded: true,
      contactExpanded: true,
      assistMaterialsList: [],
      workerBenefitsList: [],
    };
  },
  computed: {
    assistMaterialsDisplay() {
      return this.assistMaterialsList
        .filter(item => (this.project.assistMaterials || []).includes(item.code))
        .map(item => item.name)
        .join(', ');
    },
    workerBenefitsDisplay() {
      return this.workerBenefitsList
        .filter(item => (this.project.workerBenefits || []).includes(item.code))
        .map(item => item.name)
        .join(', ');
    },
  },
  mounted() {
    const dictKeys = [
      'assistMaterials', 'workerBenefits',
    ];
    Promise.all([
      getDict({ typeCodes: dictKeys }).then((result) => {
        this.assistMaterialsList = result.data.assistMaterials.codeVoList || [];
        this.workerBenefitsList = result.data.workerBenefits.codeVoList || [];
      }),
    ]).then(() => this.getInfo());
  },
  methods: {
    getInfo() {
      if (this.projectType === 'assistProject') {
        getReleaseAssist({ projectId: this.projectId }).then((result) => {
          const data = result.data || {};
          this.project = Object.assign({}, data, {
            validityDate: (data.projectRootVO || {}).validityDate || '',
            projectRootVO: data.projectRootVO || {},
            projectPublishVO: data.projectPublishVO || {},
          });
          this.perms = result.perms || {};
        });
      } else {
        getReleaseNormal({ projectId: this.projectId }).then((result) => {
          const data = result.data || {};
          this.project = Object.assign({}, data, {
            validityDate: (data.projectRootVO || {}).validityDate || '',
            projectRootVO: data.projectRootVO || {},
            projectPublishVO: data.projectPublishVO || {},
          });
          this.perms = result.perms || {};
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .assist-item-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.5rem;
    background-color: $panel-bg-color;
    font-size: 1rem;
  }

</style>



// WEBPACK FOOTER //
// src/pages/team/releaseInfo.vue